import React, { createContext, useState, useEffect} from 'react';
import Snackbar from './../Snackbar'; // adjust the path as necessary


export const SnackbarContext = createContext();

const SnackbarProvider = ({ children }) => {
    const [messages, setMessages] = useState([]);
    const [activeMessage, setActiveMessage] = useState(null);

    const triggerSnackbar = (newMessage) => {
        setMessages(prev => [...prev, { text: newMessage, key: Date.now() }]);
    };

    useEffect(() => {
        if (messages.length > 0) {
            setActiveMessage(messages[0]);
            // Set a timer to remove the first message after 3 seconds
            const timer = setTimeout(() => {
                setMessages(prev => prev.slice(1));
                setActiveMessage(null);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [messages, activeMessage]);
    return (
        <SnackbarContext.Provider value={{ triggerSnackbar }}>
            {children}
            {messages.map(msg => (
                <Snackbar key={msg.key} message={msg.text} isActive={msg.key === activeMessage?.key} />
            ))}
        </SnackbarContext.Provider >
    );
};

export default SnackbarProvider;